import React, { useState } from "react";
import logo from "../../Images/Common/ndskills logo.png";
import { Link } from "react-router-dom";
import "../../CSS/main.css";
import { ScrollToTop } from "../utils";
import { Button, Drawer } from "antd";

const navItems = [
  { name: "Home", path: "/" },
  {
    name: "About",
    dropdown: [
      {
        name: "Our Organisation",
        path: "/ourOrganisation",
      },
      { name: "Founder Profile", path: "/founderProfile" },
      // { name: "Management Team", path: "/managementTeam" },
      // { name: "Advisory Board", path: "/advisoryBoard" },
    ],
  },
  {
    name: "Schools & Programs",
    dropdown: [
      {
        name: "School of Building & Automation",
        path: "/School-of-building-automation",
      },
      { name: "School Of Data Science", path: "/School-of-datascience" },
      { name: "School of Fashion", path: "/School-of-fashion" },
      { name: "School of Health Care", path: "/School-of-healthcare" },
      // {
      //   name: "School of Search Engine Optimisation",
      //   subdropdown: [
      //     {
      //       name: "Free SEO Course",
      //       path: "/free-seo-course-in-hyderabad",
      //     },
      //     { name: "Paid SEO Course", path: "/paid-seo" },
      //   ],
      // },

      {
        name: "School of Digital Marketing",
        subdropdown: [
          {
            name: "Free SEO Course",
            path: "/free-seo-course-in-hyderabad",
          },
          {
            name: "Paid Digital Marketing Course",
            path: "/paid-digital-marketing",
          },
        ],
      },
    ],
  },
  { name: "Gallery", path: "/Gallery" },

  { name: "Jobs", path: "/Jobs" },

  { name: "Blog", path: "/Blog" },
  { name: "Contact Us", path: "/Contactus" },
];

const Header = () => {
  const [showDropDown, setShowDropDown] = useState(false);
  const [hamOpen, setHamIsOpen] = useState(false);

  const toggleNavbar = () => {
    setHamIsOpen(!hamOpen);
  };

  const onClose = () => {
    setHamIsOpen(false);
  };

  const renderNavItems = (isDropdown = false) => {
    return navItems.map((item, index) => {
      if (item.dropdown) {
        return (
          <li key={index} className="nav-item pt-1 dropdown">
            <div
              className={`nav-link textColor2 fw-bolder fs-6 dropdown-toggle btn2 `}
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {item.name}
            </div>
            <ul className="dropdown-menu">
              {item.dropdown.map((subItem, subIndex) => {
                if (!subItem.subdropdown) {
                  return (
                    <li key={subIndex}>
                      <Link
                        to={subItem.path}
                        className="dropdown-item px-4 py-2 dropdownEle"
                        onClick={() => {
                          ScrollToTop();
                          setShowDropDown(false);
                        }}
                      >
                        {subItem.name}
                      </Link>
                    </li>
                  );
                }

                return (
                  <li
                    key={subIndex}
                    className="dropdown-submenu position-relative"
                  >
                    <button
                      className="dropdown-item px-4 py-2 dropdownEle"
                      tabIndex="0"
                    >
                      {subItem.name}
                    </button>
                    <ul className="subdropdown-child-menu  ">
                      {subItem.subdropdown.map((item, i) => (
                        <li key={i}>
                          <a
                            href={item.path}
                            className="dropdown-item px-4 py-2 dropdownEle"
                            onClick={() => {
                              ScrollToTop();
                            }}
                          >
                            {item.name}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </li>
                );
              })}
            </ul>
          </li>
        );
      }
      return (
        <li
          key={index}
          className={`nav-item pt-1 ${isDropdown ? "" : "text-black"}`}
        >
          <Link
            to={item.path}
            className="nav-link textColor2 fw-bolder fs-6 btn2"
            // onClick={() => {
            //   ScrollToTop();
            //   setShowDropDown(false);
            // }}
          >
            {item.name}
          </Link>
        </li>
      );
    });
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-white sticky-top">
        <div className="container-fluid d-flex justify-content-around align-items-center ">
          <Link className="navbar-brand ps-4" to="/">
            <img className="logo-styling " src={logo} alt="ndskills logo" />
          </Link>

          <div
            className={`collapse navbar-collapse ${
              showDropDown ? "block" : ""
            }`}
            id="navbarNavDropdown"
          >
            <ul className="navbar-nav mx-auto fw-medium responsive">
              {renderNavItems()}
            </ul>
          </div>

          {/* ************************************** Hamburger Menu ********************************* */}

          <div className="d-lg-none d-xl-none text-center hamburger-icon">
            <Button onClick={toggleNavbar}>
              {hamOpen ? (
                <span className="close-icon">✖</span>
              ) : (
                <span className="navbar-toggler-icon"></span>
              )}
            </Button>
            <Drawer
              title="Menu"
              closable={false}
              onClose={onClose}
              open={hamOpen}
              placement="right"
              width={250}
              height={50}
              styles={{ body: { padding: "15px" } }}
            >
              <div className="navbar-collapse">
                <ul className="navbar-nav mx-auto fw-medium responsive">
                  {renderNavItems()}
                </ul>
              </div>
            </Drawer>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;
